import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IOverlayLoaderStore } from '../../../common/OverlayLoader.store';
import { JobSettings } from '../../components/details/JobSettings';
import { IJobDetailsService } from '../../jobDetails.service';
import { IJobDetailsFormsBl } from '../../jobDetailsForms.bl';
import { useJobPermissions } from '../../jobPermissions';
import { JOB_STATUS, TRAINING_TYPE } from '../../jobs.model';
import { withValidType } from './withValidType';

export const JobSettingsFormContainer = withValidType(
  observer((): ReactElement => {
    const jobDetailsService = useInjection(IJobDetailsService.$);
    const jobDetailsForms = useInjection(IJobDetailsFormsBl.$);
    const overlayLoader = useInjection(IOverlayLoaderStore.$);
    const permissions = useJobPermissions();

    const {
      job: { config, isOwner, status, type },
      params,
      validationErrors,
    } = jobDetailsService.store;

    const handleChangeBooleanParam = (label: string) => (): void => {
      if (label in config) {
        jobDetailsForms.handleChangeBooleanParam(label, !config[label]);
        return;
      }

      jobDetailsForms.handleChangeBooleanParam(label, true);
    };

    const handleChangeNumericParam =
      (label: string) =>
      (value: string): void => {
        jobDetailsForms.handleChangeNumericParam(label, value);
      };

    const handleBlurNumericParam =
      (label: string) =>
      (value: string): void => {
        jobDetailsForms.handleBlurNumericParam(label, value);
      };

    const hasPermission = permissions.canUpdate(isOwner).allowed;
    const editableStatus = [JOB_STATUS.DRAFT, JOB_STATUS.STOPPED, JOB_STATUS.FAILED].includes(status);

    return (
      <JobSettings
        isFormDisabled={type === TRAINING_TYPE.AUTO || !hasPermission || !editableStatus}
        parameters={params}
        validationErrors={validationErrors}
        settings={config}
        isLoading={overlayLoader.isSpinnerVisible('job-settings-list') || status === JOB_STATUS.UNKNOWN}
        onChangeNumericParam={handleChangeNumericParam}
        onBlurNumericParam={handleBlurNumericParam}
        onChangeBooleanParam={handleChangeBooleanParam}
      />
    );
  })
);
